import { OrganizerCommittee, QK } from 'ck-queries';

import { fetchWithErrorThrowing } from 'ck-utils';
import { useQuery } from '@tanstack/react-query';

export const useOrganizerCommittees = () => {
  return useQuery({
    queryKey: QK.organizerCommittees,
    queryFn: getOrganizerCommittees,
  });
};

async function getOrganizerCommittees(): Promise<OrganizerCommittee[]> {
  const res = await fetchWithErrorThrowing('/organizer-pages/committees', {
    method: 'GET',
  });

  const data: { committees: OrganizerCommittee[] } = await res.json();

  return data.committees;
}
